module.exports = {"431023001":"便江街道","431023002":"湘阴渡街道","431023101":"马田镇","431023104":"金龟镇","431023105":"柏林镇","431023106":"鲤鱼塘镇","431023109":"悦来镇","431023112":"黄泥镇","431023113":"樟树镇","431023114":"太和镇","431023115":"油麻镇","431023116":"高亭司镇","431023203":"洋塘乡","431023214":"大布江乡","431023215":"龙形市乡","431023216":"七甲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431023.json
// module id = 2021
// module chunks = 0